import { render, staticRenderFns } from "./joinQuestionnaire.vue?vue&type=template&id=fa666386&scoped=true&"
import script from "./joinQuestionnaire.vue?vue&type=script&lang=js&"
export * from "./joinQuestionnaire.vue?vue&type=script&lang=js&"
import style0 from "./joinQuestionnaire.vue?vue&type=style&index=0&id=fa666386&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa666386",
  null
  
)

export default component.exports